module.exports = __webpack_public_path__ + "static/img/practiceSystem_04.1588afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_04.png
// module id = C+Y3
// module chunks = 23